import { useEffect, useRef } from "react";
import { supabase } from "@/lib/supabase";
import { safeReturnUrl, writeSignedInHint } from "@/lib/siteSession";
import BricksLoader from "@/components/BricksLoader";

/**
 * /logout?next=<www url> — the www.brxs.ca header's "Log out".
 * The Supabase session lives in this origin's storage, so signing out has to
 * happen here. Scope "local" ends this browser's session (refresh token revoked
 * server-side) without logging the user out of their other devices.
 * Always clears the .brxs.ca hint and returns to an allow-listed www URL, even
 * if the network call fails (supabase-js still drops the local session).
 */
export default function LogoutPage() {
  const ran = useRef(false);
  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const next = safeReturnUrl(new URLSearchParams(window.location.search).get("next"));
    (async () => {
      try {
        await supabase.auth.signOut({ scope: "local" });
      } catch (error) {
        console.error("Sign-out failed:", error);
      }
      try {
        Object.keys(localStorage).filter((k) => k.startsWith("bricks-os-profile")).forEach((k) => localStorage.removeItem(k));
        sessionStorage.removeItem("bricks-os-profile");
      } catch { /* private mode */ }
      writeSignedInHint(false);
      window.location.replace(next);
    })();
  }, []);
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <BricksLoader label="Signing out" />
    </div>
  );
}
